<template>
  <div class="bg-white h-16 w-full flex items-center gap-4 px-6 border-b border-gray-100">
    <slot name="leading">
      <Link href="/" class="font-semibold text-main whitespace-nowrap shrink-0">
        ATW Builder
      </Link>
    </slot>

    <div
      v-if="$slots.actions || title"
      class="flex items-center gap-2 min-w-0 border-l border-gray-200 pl-4 ml-1"
    >
      <slot name="actions" />
      <div v-if="!$slots.actions && title" class="min-w-0 hidden sm:block">
        <p class="font-semibold truncate text-sm">{{ title }}</p>
        <p v-if="subtitle" class="text-xs text-gray-500 truncate">{{ subtitle }}</p>
      </div>
    </div>

    <div class="flex-1" />

    <div class="relative shrink-0 account-menu">
      <button
        type="button"
        class="flex items-center gap-2 rounded-lg px-2 py-1.5 hover:bg-bay transition-colors"
        aria-haspopup="true"
      >
        <div
          class="w-9 h-9 rounded-full bg-bay flex items-center justify-center text-main shrink-0"
          aria-hidden="true"
        >
          <span class="material-symbols-outlined" style="font-size: 1.35rem">account_circle</span>
        </div>
        <div class="hidden md:flex flex-col items-start text-left leading-tight max-w-[11rem]">
          <span class="text-sm font-semibold truncate w-full">{{ userName }}</span>
          <span class="text-xs text-gray-500 truncate w-full">{{ userEmail }}</span>
        </div>
        <span
          class="material-symbols-outlined text-gray-500 hidden md:inline"
          style="font-size: 1.25rem"
          aria-hidden="true"
        >expand_more</span>
      </button>

      <div class="account-menu-panel">
        <div class="account-menu-dropdown">
          <div class="px-4 py-3 border-b border-gray-100 md:hidden">
            <p class="text-sm font-semibold truncate">{{ userName }}</p>
            <p class="text-xs text-gray-500 truncate">{{ userEmail }}</p>
          </div>
          <Link
            href="/logout"
            class="flex items-center gap-2 px-4 py-2.5 text-sm text-gray-700 hover:bg-bay hover:text-main"
          >
            <span class="material-symbols-outlined" style="font-size: 1.1rem">logout</span>
            Log out
          </Link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Link, usePage } from '@inertiajs/vue3'

export default {
  components: { Link },
  props: {
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
  },
  computed: {
    authUser() {
      return usePage().props.auth?.user
    },
    userName() {
      const u = this.authUser
      if (!u) return 'Account'
      const name = [u.first_name, u.last_name].filter(Boolean).join(' ')
      return name || u.email || 'Account'
    },
    userEmail() {
      return this.authUser?.email || ''
    },
  },
}
</script>

<style scoped>
.account-menu .account-menu-panel {
  position: absolute;
  right: 0;
  top: 100%;
  padding-top: 0.35rem;
  min-width: 11rem;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.15s ease, visibility 0.15s ease;
  z-index: 50;
}

.account-menu-dropdown {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.account-menu:hover .account-menu-panel,
.account-menu:focus-within .account-menu-panel {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}
</style>
